import React from 'react';
import GridView from './GridView';

class FavoritesView extends GridView {
  getRealtyList () {
    return this.props.data.map(this.getRealtyRow);
  }

  render () {
    return (
      <div className='favorites-grid'>
        { super.render() }
      </div>
    );
  }
}

FavoritesView.propTypes = {};
FavoritesView.defaultProps = {};

export default FavoritesView;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FavoritesView.jsx